import React from 'react';
import { Envelope, Telegram, Whatsapp } from 'react-bootstrap-icons';

import { Space, Typography } from 'antd';

import { openInNewTab } from '@/helpers';
import { enContactType } from '@/interfaces/contactChannel';
import { useGetContactsQuery } from '@/services/contacts';
import styled, { StyledProp, css } from '@/styled';

interface IContactProps extends StyledProp {
  courseId: number;
}

const ContactChannel: React.FC<IContactProps> = ({ courseId, className }) => {
  const { data } = useGetContactsQuery(courseId);

  const copyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    console.log('E-mail copiado!');
  };

  const icons: Record<enContactType, JSX.Element> = {
    [enContactType.WHATSAPP_PHONE]: <Whatsapp />,
    [enContactType.TELEGRAM_PHONE]: <Telegram />,
    [enContactType.EMAIL]: <Envelope />,
    [enContactType.GENERIC_LINK_STUDY]: <Whatsapp />,
    [enContactType.GENERIC_LINK_WARNING]: <Whatsapp />,
    [enContactType.GENERIC_LINK_CONTENT]: <Whatsapp />
  };

  const names: Record<enContactType, string> = {
    [enContactType.WHATSAPP_PHONE]: 'WhatsApp do produtor',
    [enContactType.TELEGRAM_PHONE]: 'Telegram do produtor',
    [enContactType.EMAIL]: 'E-mail de suporte',
    [enContactType.GENERIC_LINK_STUDY]: 'Grupo de estudos',
    [enContactType.GENERIC_LINK_WARNING]: 'Grupo de avisos',
    [enContactType.GENERIC_LINK_CONTENT]: 'Grupo de materiais'
  };

  const links: Record<enContactType, (data: string) => void> = {
    [enContactType.WHATSAPP_PHONE]: data => openInNewTab(`https://wa.me/55${data}`),
    [enContactType.TELEGRAM_PHONE]: link => openInNewTab(link),
    [enContactType.EMAIL]: copyEmail,
    [enContactType.GENERIC_LINK_STUDY]: data => openInNewTab(data),
    [enContactType.GENERIC_LINK_WARNING]: data => openInNewTab(data),
    [enContactType.GENERIC_LINK_CONTENT]: data => openInNewTab(data)
  };

  const handleClick = (type: enContactType, data: string) => {
    return links[type](data);
  };

  return (
    <Space className={className} size={32} direction='vertical'>
      {data?.map((contact, index) => (
        <Space key={index} direction='horizontal' size={18}>
          {icons[contact.type]}
          <Typography.Link onClick={() => handleClick(contact.type, contact.data)}>
            {names[contact.type]}
          </Typography.Link>
        </Space>
      ))}
    </Space>
  );
};

export default styled(ContactChannel)(
  ({ theme }) => css`
    margin-left: ${theme.space.pxToRem(16)};

    .ant-typography {
      font-size: ${theme.space.pxToRem(16)};
    }

    svg {
      font-size: ${theme.space.pxToRem(24)};
    }

    .ant-space-item {
      width: fit-content;
    }
  `
);
